import './report-viewer.scss';
import React, {useEffect, useMemo, useState} from 'react';
import {useLocation, useParams} from 'react-router-dom';
import {InsightsSubMenu, MainPages, ReportName} from 'src/utils/enums';
import {observer} from 'mobx-react-lite';
import {useStores} from 'src/components/store';
import {removeSpacesAndStartWithLowerCase} from '@src/utils/string-normalization';
import {handleDateRange} from '@src/utils/datesUtils';
import ExecutiveSummary from '../../executive-summary/ExecutiveSummary';
import useReportFilters from './useReportFilters';
import {ExportReport} from '@src/components/features/reports-and-logs/new-reports/export-report';
import {ReportContent} from '@src/components/features/reports-and-logs/new-reports/report-content';

const ReportViewer: React.FC = observer(() => {
    const { reportsStore, uiStore, customerStore } = useStores();
    const params = useParams();
    const reportType = params.reportType as ReportName;
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(false);

    const {filters, filtersReportName, FilterControls} = useReportFilters(reportType, state);

    const transformedReportName = useMemo(() =>
            reportType ? removeSpacesAndStartWithLowerCase(reportType ?? '') : ''
        , [reportType]);

    useEffect(() => {
        if (customerStore.selectedCustomer && customerStore.selectedLocation && transformedReportName) {
            uiStore.sendPageViewEvent(MainPages.INSIGHTS, InsightsSubMenu.REPORTS, transformedReportName);
        }
    }, [customerStore.selectedCustomer, customerStore.selectedLocation, transformedReportName]);

    if (reportType === ReportName.EXECUTIVE_SUMMARY && reportsStore.dateRange) {
        const { fromDate, toDate } = handleDateRange(reportsStore.dateRange);
        return <ExecutiveSummary fromDate={fromDate} toDate={toDate} />;
    }

    return (
        <div className="report report-viewer">
            <div className="report-content-header header-page">
                <div>
                    <div className="title">{reportType}</div>
                </div>
                <div className="report-header-actions">
                    {FilterControls}
                    <ExportReport reportName={transformedReportName} isLoading={isLoading} contentClass={'report-viewer'} />
                </div>
            </div>
            <ReportContent reportName={reportType} isLoading={isLoading} setIsLoading={setIsLoading}
                           filters={filters} filtersReportName={filtersReportName}/>
        </div>
    );
});

export default ReportViewer;
